import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { exercisePropTypes } from '../../../constants/exercise';

import FindErrorFeedback from '../../feedback/find-error';
import MathContent from '../../math-content';
import TextHighlighter, { HighlightType } from '../../text-highlighter';
import { getHightlightType } from '../../exercise/find-error';

export const QuestionContainer = styled.div`
    padding: 0 0 0 32px;
`;

const FindErrorCorrection = ({ answers, exercise, solution, correctionStatus }) => {
    const myAnswers = answers ? answers.answer : [];
    return (
        <>
            <QuestionContainer>
                {exercise.prompt && <MathContent>{exercise.prompt}</MathContent>}
                <br />
                <TextHighlighter
                    question={exercise.plainQuestionWrong}
                    highlights={
                        myAnswers &&
                        myAnswers.map((answer) => ({
                            ...answer,
                            type: solution
                                ? HighlightType.CORRECT
                                : getHightlightType(exercise, myAnswers.length, answer, correctionStatus),
                        }))
                    }
                    disabled={true}
                />
            </QuestionContainer>

            <FindErrorFeedback answers={myAnswers} exercise={exercise} />
        </>
    );
};
FindErrorCorrection.propTypes = {
    exercise: PropTypes.shape({
        ...exercisePropTypes.propTypes,
        plainQuestionCorrect: PropTypes.string,
        plainQuestionWrong: PropTypes.string,
        prompt: PropTypes.string,
        correctWords: PropTypes.arrayOf(PropTypes.object),
        wrongWords: PropTypes.arrayOf(PropTypes.object),
    }),
    answers: PropTypes.shape({
        exerciseId: PropTypes.number,
        answer: PropTypes.array,
    }),
    solution: PropTypes.bool,
    correctionStatus: PropTypes.object,
};

export default FindErrorCorrection;
